import { render, staticRenderFns } from "./deleteware.vue?vue&type=template&id=003c97dc"
import script from "./deleteware.vue?vue&type=script&lang=js"
export * from "./deleteware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports